import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Shield, MessageCircle } from 'lucide-react';
import PolicyLayout from './PolicyLayout';
import { getWhatsAppLink } from '../lib/utils';

function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - OldCoinage.com</title>
        <meta name="description" content="Learn how OldCoinage.com protects and handles your personal information." />
      </Helmet>

      <PolicyLayout title="Privacy Policy" lastUpdated="March 15, 2024">
        <div className="bg-indigo-50 border border-indigo-100 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-4">
            <Shield className="h-6 w-6 text-indigo-600 mt-1" />
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">Your Privacy is Our Priority</h2>
              <p className="text-gray-600">
                At OldCoinage.com, we are committed to protecting your privacy and ensuring the security of your personal information.
              </p>
            </div>
          </div>
        </div>

        <h2>Information We Collect</h2>
        <p>
          We collect information that you provide directly to us, including:
        </p>
        <ul>
          <li>Name and contact information</li>
          <li>Delivery addresses</li>
          <li>Payment information</li>
          <li>Communication preferences</li>
          <li>Transaction history</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <p>
          Your information helps us provide and improve our services:
        </p>
        <ul>
          <li>Process your transactions</li>
          <li>Deliver your purchases</li>
          <li>Send important updates</li>
          <li>Improve our platform</li>
          <li>Provide customer support</li>
        </ul>

        <h2>Information Security</h2>
        <p>
          We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
        </p>

        <h2>Your Rights</h2>
        <p>
          You have the right to:
        </p>
        <ul>
          <li>Access your personal information</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of marketing communications</li>
        </ul>

        <div className="bg-primary-50 border border-primary-100 rounded-lg p-6 mt-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Contact Us</h2>
          <p className="text-gray-600 mb-4">
            If you have any questions about our Privacy Policy or how we handle your information, please contact us:
          </p>
          <a
            href={getWhatsAppLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-full hover:bg-primary-700 transition-colors font-medium"
          >
            <MessageCircle className="h-5 w-5" />
            Chat on WhatsApp
          </a>
        </div>
      </PolicyLayout>
    </>
  );
}

export default PrivacyPolicy;